import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router";
import { useEffect, useRef } from "react";
import { i18n } from "~/localization/i18n";
import { RedirectPage } from "../RedirectPage/RedirectPage";
import { GREETING_SHOWN_KEY } from "~/components/Home/Greeting/Greeting";
import { useCompleteInitiation } from "~/hooks/api/account/useCompleteInitiation";
import {
  trackAppInsightsTelemetry,
  TRACK_METHOD,
} from "~/logging/applicationInsightsService";

export const SigninCallback = () => {
  const { user, isLoading } = useAuth();
  const navigate = useNavigate();
  const { completeInitiation } = useCompleteInitiation();
  const initiationRequested = useRef(false);

  useEffect(() => {
    if (isLoading) {
      return;
    }

    if (!user) {
      navigate("/");
      return;
    }

    // StrictMode runs effects twice in development; a second call could send the username message twice.
    if (initiationRequested.current) {
      return;
    }
    initiationRequested.current = true;

    i18n.changeLanguage(user.profile.lang);
    sessionStorage.removeItem(GREETING_SHOWN_KEY);

    // Called on every sign-in so a failed attempt is retried next time; Viedoc4Me decides from DB state (ADR-002).
    completeInitiation()
      .then((result) => navigate(result?.sentReference ? "/welcome" : "/"))
      .catch((error) => {
        trackAppInsightsTelemetry(
          {
            exception: error,
            properties: { operation: "complete-initiation" },
          },
          TRACK_METHOD.EXCEPTION,
        );
        navigate("/");
      });
  }, [isLoading, user, navigate, completeInitiation]);

  return <RedirectPage />;
};
